// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"727533bb","72":"c666278f","207":"14922dc0","238":"455a4933","294":"1b28afb2","307":"e26901d0","312":"98ea8ed9","375":"fb3d8785","539":"8faae4d3","600":"4a745ce4","779":"26ffb737","979":"bee231f4"}[chunkId] + ".chunk.js";
};